<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-5">Acknowledgments</h1>
<p class="para-first"><span class="dropcap">M</span>any students, colleagues, and friends have assisted me in writing this book. I especially wish to thank those who read its early drafts in whole or in part and offered helpful comments: Cornelius Plantinga Jr., George S. Hendry, Hugh T. Kerr, Nancy Duff, Kathleen D. Billman, and Leanne Van Dyk.</p>
<p class="indent-para">I am also indebted to George Stroup, Michael Welker, Ellen Charry, Sang Hyun Lee, Mark Kline Taylor, and David E. Willis-Watkins, with each of whom at various times I taught the basic course in theology at Princeton Theological Seminary. Just how much their ideas enriched my own would be embarrassing to relate in detail.</p>
<p class="indent-para">I am grateful to Presidents Thomas Gillespie and Iain Torrance, and to the Trustees of Princeton Theological Seminary for sabbatical leaves that enabled me to complete the several editions of the book.</p>
<p class="indent-para">My gratitude to my wife Margaret (†2017) for her love and support as well as for her wise editorial advice is far greater than I can say.</p>
<p class="indent-para">Finally, I want to express my thanks to the many first-year MDiv students in TH01 who patiently listened to versions of some of the chapters. Their questions, suggestions, and encouragement were a constant source of strength and joy to me. To all these students this book is gratefully dedicated.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010_Ack.vue?1f83e1fb